import { useState } from 'react'

import csrfHeaders from 'src/utils/csrfHeaders'

import { genericError } from './useRecord'

// `tbd` is the accurate internal name — the donor is pledging to donate
// later, and the final payment method is genuinely To Be Decided until
// they click the follow-up email link and complete the donation through
// the form. Externally we call it "Pledge" for the donor (which clashes
// with the brand name and may get renamed later), but internally `tbd`
// stays — wire/check pass straight through.
const PAYMENT_SOURCE = { wire: 'wire', check: 'check', pledge: 'tbd' }
const PAYMENT_METHOD_USED = { wire: 'Wire', check: 'Check', pledge: 'TBD' }

const useDeferredPayment = ({
  i18n, donation, record, paymentMethod, partnerItem,
  submitPath, finished, setSubmitInFlight,
}) => {
  const [ errors, setErrors ] = useState(null)

  // Drop the App-level overlay (App.jsx flipped it on before
  // sendPayment) and surface the inline alert on the deferred-payment
  // step. Callers pass an already-shaped { base: [...] } — saveDraft
  // normalizes its own controller's response, and the deferred
  // branch normalizes its 422 body inline below.
  const fail = errors => {
    setSubmitInFlight(false)
    setErrors(errors)
  }

  const sendPayment = async ({ bankName, last4 } = {}) => {
    try {
      const { errors, token, serializedDonation } = await record.saveDraft({
        // Wire/check/pledge settle off-platform — no tip or fee-covering.
        principalOnly: true,
        order: {
          bank_name:          bankName,
          last4:              last4,
          payment_source:     PAYMENT_SOURCE[paymentMethod],
          payment_method_used: PAYMENT_METHOD_USED[paymentMethod],
        },
      })
      if (errors) return fail(errors)

      const response = await fetch(submitPath, {
        method: 'POST',
        headers: csrfHeaders(),
        body: JSON.stringify({ order_id: token }),
      })

      if (response.ok) {
        const { state, ...rest } = donation
        finished({
          ...state,
          ...rest,
          ...serializedDonation,
          token,
          partnerItem,
        })
      } else {
        // deferred_donations#create renders { errors: @order.errors }
        // — pull base out (only base belongs on the payment alert) and
        // fall back to a generic message if a non-base validation
        // somehow surfaced here.
        const { errors: orderErrors = {} } = await response.json()
        fail(orderErrors.base?.length ? { base: orderErrors.base } : genericError(i18n))
      }
    } catch (error) {
      console.error(error)
      fail(genericError(i18n))
    }
  }

  return { sendPayment, errors, setErrors }
}

export default useDeferredPayment
